import React, { useEffect, useState } from "react";
import { Pressable, ScrollView, StyleSheet, Text, View } from "react-native";
import { useNavigation, useRoute } from "@react-navigation/native";
import ReportBackground from "../components/ReportBackground";
import ReportIndicatorList from "../components/ReportIndicatorList";
import { ArrowLeft } from "../assets/icons";
import { getReportStatistic } from "../services/reportStatistics";

export default function ReportIndicatorDetail() {
  const navigation = useNavigation();
  const route = useRoute();
  const character = route.params?.character || "Santun";
  const showAllIndicators = route.params?.showAllIndicators === true;
  const reportType = route.params?.reportType;
  const reportId = route.params?.id;
  const [summary, setSummary] = useState(route.params?.summary || null);
  const [loading, setLoading] = useState(!route.params?.summary && !route.params?.indicatorGroups);
  const [loadError, setLoadError] = useState(false);
  const period = route.params?.period || summary?.periode || "";

  useEffect(() => {
    if (route.params?.summary || route.params?.indicatorGroups) return;
    if (!reportId) {
      setLoadError(true);
      setLoading(false);
      return undefined;
    }

    let active = true;
    getReportStatistic(reportId)
      .then(({ data }) => {
        if (!active) return;
        const selectedSummary = data?.summaries?.find((item) => item.periode === period) || data?.summaries?.[0] || null;
        setSummary(selectedSummary);
      })
      .catch(() => {
        if (active) setLoadError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [reportId]);

  const selectedCharacter = summary?.characters?.find(
    (item) => item.name?.toLowerCase() === character.toLowerCase()
  ) || summary?.characters?.[0];
  const indicatorGroups = reportType === "materials"
    ? route.params?.indicatorGroups || []
    : showAllIndicators
      ? summary?.characters || []
      : selectedCharacter
        ? [selectedCharacter]
        : [];

  return (
    <ReportBackground style={styles.screen}>
      <ScrollView contentContainerStyle={styles.content}>
        <View style={styles.pageHeader}>
          <Pressable onPress={() => navigation.goBack()} style={styles.backButton}>
            <ArrowLeft />
          </Pressable>
          <Text style={styles.pageTitle}>
            {showAllIndicators
              ? reportType === "materials" ? "Semua Indikator Kompetensi" : "Semua Indikator"
              : "Indikator"}
          </Text>
        </View>
        <ReportIndicatorList
          characters={indicatorGroups}
          loading={loading}
          loadError={loadError}
        />
      </ScrollView>
    </ReportBackground>
  );
}

const styles = StyleSheet.create({
  screen: { flex: 1 },
  content: { paddingHorizontal: 14, paddingTop: 44, paddingBottom: 28, gap: 16 },
  pageHeader: { height: 42, borderRadius: 24, backgroundColor: "#FFFFFF", flexDirection: "row", alignItems: "center", justifyContent: "center" },
  backButton: { position: "absolute", left: 14, width: 28, height: 32, justifyContent: "center" },
  pageTitle: { color: "#171717", fontFamily: "Archivo-Bold", fontSize: 12 },
});